export default {
	"client": "Клиент",
	"mechanic": "Механик",
	"admin": "Админ",
	"consultant": "Консультант",
}